var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSale = function SvgSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "m11.5 1.5 1.831 3.168L16.5 2.84l.002 3.658 3.658.002-1.828 3.169L21.5 11.5l-3.168 1.831L20.16 16.5l-3.658.002-.002 3.658-3.169-1.828L11.5 21.5l-1.831-3.168L6.5 20.16l-.002-3.658L2.84 16.5l1.828-3.169L1.5 11.5l3.168-1.831L2.84 6.5l3.658-.002L6.5 2.84l3.169 1.828zm-3 14 6-8M15 14c0 .828-.447 1.5-1 1.5-.553 0-1-.672-1-1.5s.447-1.5 1-1.5c.553 0 1 .672 1 1.5zm-5-5c0 .828-.447 1.5-1 1.5-.553 0-1-.672-1-1.5s.447-1.5 1-1.5c.553 0 1 .672 1 1.5z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgSale as ReactComponent };
export default __webpack_public_path__ + "ad13d9dfcd52d79dcdbc445b005f6959.svg";